<template>
  <div id="mayra">
    <div class="container-marcas">
      <div class="banner">
        <!-- <img src="@/assets/images/melonMayra.png" alt="Uva"> -->
        <div class="titulo">
          <p>FRUTAS MAYRA</p>
        </div>
      </div>
      <div class="desc">
        <p class="bold">
          La primera compañía del Grupo y la madre de todas las empresas,
          fue constituida formalmente en Abril de 1994 y arrancó operaciones el 2 de Enero de 1995.
        </p>
        <p>
          Se especializa en la comercializacion de melón en sus diferentes variedades:
          Cantaloupe, Honeydew y Exóticas, además de guayaba nacional y sandía nacional
          de importación.
        </p>
        <p>
          Frutas Mayra, hoy más que nunca,esta comprometida con sus clientes para garantizar
          la excelencia en calidad, servicio y precios.
        </p>
      </div>
      <div class="fotos">
        <div class="flex items-center justify-between">
          <div class="foto w-30">
            <img src="@/assets/images/mayra1.jpg" alt="Galeria">
          </div>
          <div class="foto w-30">
            <img src="@/assets/images/mayra2.jpg" alt="Galeria">
          </div>
          <div class="foto w-30">
            <img src="@/assets/images/mayra3.jpg" alt="Galeria">
          </div>
        </div>
        <div class="flex items-center justify-between">
          <div class="foto w-30">
            <img src="@/assets/images/mayra4.jpg" alt="Galeria">
          </div>
          <div class="foto w-30">
            <img src="@/assets/images/mayra/cubiculos.jpg" alt="Galeria">
          </div>
          <div class="foto w-30">
            <img src="@/assets/images/mayra/exterior.jpg" alt="Galeria">
          </div>
        </div>
      </div>
      <div class="ubicacion">
        <div class="flex-ubi">
          <div class="map">
            <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.9732944505613!2d-99.09009968461383!3d19.37030898691977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1fdc37a327f69%3A0x71517da4abebbf1e!2sGRUPO+MLA!5e0!3m2!1ses-419!2smx!4v1547220444411"
            width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div>
          <div class="direccion">
            <p class="bold">Frutas Mayra, S.A. de C.V.</p>
            <p>Zona V, sector 5, nave 4,</p>
            <p>bodega Q-177</p>
            <p>Col. Central de Abasto</p>
            <p>09040, Iztapalapa, Mexico, D.F.</p>
            <p>Conmutador: [52255] 5640 2270</p>
            <p>t. [5255] 5694 9463</p>
            <p>y [5255] 5600 3303</p>
            <p class="underline">administracion@grupomla.com.mx</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss">
#mayra {
  // p {
  //   font-size: 1.3em;
  // }
  .container-marcas {
    .banner {
      background: url('../../assets/images/mayraMelon.png');
      background-position: right;
      background-size: cover;
      height: 80vh;
      width: 100%;
      position: relative;

      img {
        z-index: 1;
        width: 100%;
        height: 100%;
      }

      .titulo {
        position: absolute;
        color: #fff;
        font-size: 2.2em;
        font-weight: bold;
        top: 5%;
        left: 4%;
      }

    }
    .desc {
      font-size: 1.3em;
      padding: 0 10%;
      padding-bottom: 50px;
      margin-bottom: 50px;

      .bold {
        font-weight: bold;
      }

    }
    .fotos {
      width: 90%;
      margin: 0 auto;
      margin-bottom: 50px;

      .flex {
        .foto {
          margin: 10px 10px;;
        }
      }

    }
    .ubicacion {
      width: 80%;
      margin: 0 auto;

      .flex-ubi {
        height: 70vh;
        display: flex;
        justify-content: center;

        .map {
          width: 50%;
        }
        .direccion {
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: 5px;


          .bold {
            font-weight: bold;
          }

          .underline {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 950px) {
  .container-marcas {
    .banner {
      .titulo {
        left: 10% !important;
      }
    }
    .flex {
      flex-direction: column;
    }
  }
  .flex-ubi {
    flex-direction: column;

    > div {
      width: 100% !important;
       padding-bottom: 10vh;
    }
    .map {
      height: 40vh;
    }
  }
  div#mayra .container-marcas div.banner div.titulo {
    left: 30% !important;
  }
  div.container-marcas div.ubicacion div.flex-ubi {
    height: auto !important;
    margin-left: 0;
    margin-right: 0;
  }
   div.container-marcas div.ubicacion {
     margin: 0 !important;
     width: 100% !important;
   }
}
</style>
